<template>
  <div class="inject-page-host" style="width:100%;height:100%;min-height:400px;"></div>
</template>

<script>
export default {
  name: 'BimModel',
  mounted() {
    const el = this.$el
    this.$nextTick(() => {
      if (window.BIM_mount) window.BIM_mount(el)
    })
  },
  beforeDestroy() {
    if (window.BIM_destroy) window.BIM_destroy()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/BimModel/index.vue